export enum ShopId {
  DE = 'DE',
  CH = 'CH',
  PL = 'PL',
}
